// import JS files
import '../kickstart';
import './ballot-sticky-nav-bar';

import { h, render } from 'preact';

// Components
import App from '../BallotApp';
import loadJsonScript from '../utils/load-json-script';

const notes = loadJsonScript('notes_data');

render(
  <App notes={notes} />,
  document.getElementById('app')
);